// extracted by mini-css-extract-plugin
export default {"commentBox":"xv_9yP","lockedState":"wh0sAz","root":"xYy6K7","isMobile":"xOp2jf"};